import { render, staticRenderFns } from "./PaymentRunPoliciesModal.vue?vue&type=template&id=3bc1e954&scoped=true&"
import script from "./PaymentRunPoliciesModal.vue?vue&type=script&lang=js&"
export * from "./PaymentRunPoliciesModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRunPoliciesModal.vue?vue&type=style&index=0&id=3bc1e954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1e954",
  null
  
)

export default component.exports